import { Box } from "@mui/system";
import { Dashboard_Content } from "../../../Utils/Constants";
import { useLocation, useNavigate } from "react-router-dom";
import { Path } from "../../../Utils/ScreenPath";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { postMachinesList } from "../../../services/machineService";
import { ApplicationId } from "../../../api/url";
import { Img } from "react-image";
import CopyIcon from "../../../assets/img/images/copy.png";
import CheckList from "../../../assets/img/svg/checkList.svg";
import GridIcon from "../../../assets/img/svg/Grid_Icon.svg";
import SelectIcon from "../../../assets/img/svg/select-icon.svg";
import FilterIcon from "../../../assets/img/svg/equalizer-line.svg";
import { Grid, Menu, MenuItem } from "@mui/material";

export const MachineBoxUseCopy = ({
  notShowCheckBox,
  MachineDetails,
  selecedEquipment,
  setSelecedEquipment,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const encodeURICom = encodeURIComponent(
    `${
      MachineDetails?.year || ""
    }-${MachineDetails?.manufacturer?.name?.replaceAll(" ", "")}-${
      MachineDetails?.model?.number
    }-${MachineDetails.unit_number}`
  )
    ?.toLowerCase()
    .replaceAll(" ", "-");
  const category = encodeURIComponent(
    `${MachineDetails?.model?.subcategory?.name
      ?.toLowerCase()
      .replaceAll(" ", "-")}`
  );
  const RPath = `${Path.Inventory}/${category}/${MachineDetails.id}/${encodeURICom}`;

  return (
    <>
      <table className="MachineList_Box">
        <tr>
          <td>
            <Img src={MachineDetails.primary_image.url} width={150} />
          </td>
          <td>
            <table>
              <tr>
                <td>
                  <table className="MachineList_Title_Box">
                    <tr>
                      <td
                        // style={{ fontWeight: "bold" }}
                        className="MachineList_Title MachineList_Title_Hover"
                      >
                        <a href={RPath} style={{ fontWeight: "400" }}>
                          {MachineDetails?.listing_title ? (
                            MachineDetails?.listing_title
                          ) : (
                            <>
                              {MachineDetails?.model?.manufacturer?.name}{" "}
                              {MachineDetails?.model?.number}{" "}
                              {MachineDetails?.year
                                ? `(${MachineDetails?.year})`
                                : null}{" "}
                              {MachineDetails?.unit_number
                                ? ` UNIT # ${MachineDetails?.unit_number}`
                                : null}
                            </>
                          )}
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td
                        // style={{ fontWeight: "bold" }}
                        className="MachineList_Title"
                      >
                        <a
                          href={RPath}
                          style={{
                            textDecoration: "none",
                            color: "#000",
                            fontWeight: "400",
                          }}
                        >
                          {MachineDetails.meter_reading
                            ? `${t("Dashboard_Content_MACHINE_HOURS")}: ${
                                MachineDetails.meter_reading
                              }`
                            : `${t("Dashboard_Content_MACHINE_HOURS")}: N/A`}
                        </a>
                      </td>
                    </tr>
                  </table>
                  <table>
                    <tr>
                      <td
                        className="MachineList_description"
                        // style={{ fontSize: "12px" }}
                      >
                        {MachineDetails.description}
                        <div
                          dangerouslySetInnerHTML={{
                            __html: MachineDetails?.inlist_description_html,
                          }}
                        ></div>
                      </td>
                    </tr>
                    <tr>
                      <td
                        // style={{ fontWeight: "bold" }}
                        className="MachineList_Title"
                        style={{ textAlign: "right", fontSize: "16px" }}
                      >
                        <a href={RPath}>{t("Dashboard_Content_Click_here")}</a>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </>
  );
};

export const MachineBox = ({
  notShowCheckBox,
  MachineDetails,
  selecedEquipment,
  setSelecedEquipment,
  selectedCheckList,
  machineRefs,
  index,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  let newTitle = MachineDetails?.listing_title;

  return (
    <>
      <Box
        className="MachineList_Box"
        ref={(el) => (machineRefs.current[index] = el)}
        id={`machine-id-${MachineDetails?.id}`}
      >
        {!notShowCheckBox && (
          <Box display={"flex"} alignItems={"center"}>
            {selectedCheckList && (
              <input
                type="checkbox"
                className="checkbox"
                checked={
                  selecedEquipment?.find(
                    (item) => item.id === MachineDetails.id
                  ) || false
                }
                onClick={(e) => {
                  if (e.target.checked) {
                    setSelecedEquipment([...selecedEquipment, MachineDetails]);
                  } else {
                    const newData = selecedEquipment?.filter(
                      (item) => item.id !== MachineDetails.id
                    );
                    setSelecedEquipment(newData);
                  }
                }}
              />
            )}
          </Box>
        )}
        <Box className="MachineList_img">
          <img src={MachineDetails.primary_image.url} alt="" width={"100%"} />
        </Box>
        <Box className="MachineList_dis">
          <Box>
            <Box className="MachineList_Title_Box">
              <Box
                className="MachineList_Title MachineList_Title_Hover"
                onClick={() => {
                  if (!notShowCheckBox) {
                    window.scrollTo({
                      top: 0,
                      behavior: "smooth",
                    });

                    const encodeURICom = encodeURIComponent(
                      `${MachineDetails?.year || ""}-${
                        MachineDetails?.manufacturer?.name
                      }-${MachineDetails?.model?.number?.replaceAll(" ", "")}-${
                        MachineDetails.unit_number
                      }`
                    )
                      ?.toLowerCase()
                      .replaceAll(" ", "-");

                    const category = encodeURIComponent(
                      `${MachineDetails?.model?.subcategory?.name
                        ?.toLowerCase()
                        .replaceAll(" ", "-")}`
                    );
                    navigate(
                      `${Path.Inventory}/${category}/${MachineDetails.id}/${encodeURICom}`,
                      {
                        state: MachineDetails,
                      }
                    );
                    // window.location.reload();
                  }
                }}
              >
                {newTitle ? (
                  newTitle
                ) : (
                  <>
                    {/* {MachineDetails.manufacturer?.name} */}
                    {MachineDetails?.model?.manufacturer?.name}{" "}
                    {MachineDetails?.model?.number}{" "}
                    {MachineDetails?.year ? `(${MachineDetails?.year})` : null}{" "}
                    {MachineDetails?.unit_number
                      ? ` UNIT # ${MachineDetails?.unit_number}`
                      : null}
                  </>
                )}
              </Box>
              {MachineDetails.meter_reading ? (
                <Box className="MachineList_Title">
                  {t("Dashboard_Content_MACHINE_HOURS")}:{" "}
                  {MachineDetails.meter_reading}
                </Box>
              ) : (
                <Box className="MachineList_Title">
                  {t("Dashboard_Content_MACHINE_HOURS")}: N/A
                </Box>
              )}
            </Box>
            <Box>
              <Box className="MachineList_description">
                {MachineDetails.description}

                <div
                  dangerouslySetInnerHTML={{
                    __html: MachineDetails?.inlist_description_html,
                  }}
                ></div>
                {/* <div className='EquipmentCard_DETAIL_Box'>
                  <div className='EquipmentCard_DETAILS'>DETAILS:</div>
                  <div className='EquipmentCard_DETAILS'>{MachineDetails?.manufacturer?.name}</div>
                  <div className='EquipmentCard_DETAILS'>{MachineDetails?.model?.number}</div>
                  <div className='EquipmentCard_DETAILS'>{MachineDetails?.year}</div>
                  <div className='EquipmentCard_DETAILS'>{MachineDetails?.meter_reading}</div>
                </div> */}
              </Box>
            </Box>
          </Box>
          <Box>
            <Box
              className="MachineList_Click_here_Text"
              onClick={() => {
                if (!notShowCheckBox) {
                  window.scrollTo({
                    top: 0,
                    behavior: "smooth",
                  });

                  const encodeURICom = encodeURIComponent(
                    `${MachineDetails?.year || ""}-${
                      MachineDetails?.manufacturer?.name
                    }-${MachineDetails?.model?.number?.replaceAll(" ", "")}-${
                      MachineDetails.unit_number
                    }`
                  )
                    ?.toLowerCase()
                    .replaceAll(" ", "-");

                  const category = encodeURIComponent(
                    `${MachineDetails?.model?.subcategory?.name
                      ?.toLowerCase()
                      .replaceAll(" ", "-")}`
                  );
                  navigate(
                    `${Path.Inventory}/${category}/${MachineDetails.id}/${encodeURICom}`,
                    {
                      state: MachineDetails,
                    }
                  );
                  // window.location.reload();
                }
              }}
            >
              {t("Dashboard_Content_Click_here")}
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export const GridMachineBox = ({
  notShowCheckBox,
  MachineDetails,
  selecedEquipment,
  setSelecedEquipment,
  selectedCheckList,
  machineRefs,
  index,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  let newTitle = MachineDetails?.listing_title;
  return (
    <>
      <Box
        className="MachineList_Grid_Box"
        position={"relative"}
        bgcolor={"#FFFFFF"}
        id={`machine-id-${MachineDetails?.id}`}
        ref={(el) => (machineRefs.current[index] = el)}
      >
        {!notShowCheckBox && (
          <Box display={"flex"} alignItems={"center"} position={"absolute"}>
            {selectedCheckList && (
              <input
                type="checkbox"
                className="checkbox"
                checked={
                  selecedEquipment?.find(
                    (item) => item.id === MachineDetails.id
                  ) || false
                }
                onClick={(e) => {
                  if (e.target.checked) {
                    setSelecedEquipment([...selecedEquipment, MachineDetails]);
                  } else {
                    const newData = selecedEquipment?.filter(
                      (item) => item.id !== MachineDetails.id
                    );
                    setSelecedEquipment(newData);
                  }
                }}
              />
            )}
          </Box>
        )}
        <Box className="MachineList_Grid_img">
          <img src={MachineDetails.primary_image.url} alt="" width={"100%"} />
        </Box>
        <Box className="MachineList_Grid_dis">
          <Box>
            <Box className="MachineList_Title_Box" textAlign={"start"}>
              <Box
                className="MachineList_Grid_Title"
                onClick={() => {
                  if (!notShowCheckBox) {
                    window.scrollTo({
                      top: 0,
                      behavior: "smooth",
                    });

                    const encodeURICom = encodeURIComponent(
                      `${MachineDetails?.year || ""}-${
                        MachineDetails?.manufacturer?.name
                      }-${MachineDetails?.model?.number?.replaceAll(" ", "")}-${
                        MachineDetails.unit_number
                      }`
                    )
                      ?.toLowerCase()
                      .replaceAll(" ", "-");
                    const category = encodeURIComponent(
                      `${MachineDetails?.model?.subcategory?.name
                        ?.toLowerCase()
                        .replaceAll(" ", "-")}`
                    );
                    navigate(
                      `${Path.Inventory}/${category}/${MachineDetails.id}/${encodeURICom}`,
                      {
                        state: MachineDetails,
                      }
                    );
                  }
                }}
              >
                {newTitle ? (
                  newTitle
                ) : (
                  <>
                    {MachineDetails?.model?.manufacturer?.name}{" "}
                    {MachineDetails?.model?.number}{" "}
                    {MachineDetails?.year ? `(${MachineDetails?.year})` : null}{" "}
                    {MachineDetails?.unit_number
                      ? ` UNIT # ${MachineDetails?.unit_number}`
                      : null}
                  </>
                )}
              </Box>
              {MachineDetails.meter_reading ? (
                <Box className="MachineList_Grid_Hours_Title">
                  {t("Dashboard_Content_MACHINE_HOURS")}:{" "}
                  {MachineDetails.meter_reading}
                </Box>
              ) : (
                <Box className="MachineList_Grid_Hours_Title">
                  {t("Dashboard_Content_MACHINE_HOURS")}: N/A
                </Box>
              )}
            </Box>
            <Box>
              <Box className="MachineList_Grid_description">
                {MachineDetails.description}

                <div
                  dangerouslySetInnerHTML={{
                    __html: MachineDetails?.inlist_description_html,
                  }}
                ></div>
              </Box>
            </Box>
          </Box>
          <Box>
            <Box
              className="MachineList_Click_Grid_here_Text"
              onClick={() => {
                if (!notShowCheckBox) {
                  window.scrollTo({
                    top: 0,
                    behavior: "smooth",
                  });

                  const encodeURICom = encodeURIComponent(
                    `${MachineDetails?.year || ""}-${
                      MachineDetails?.manufacturer?.name
                    }-${MachineDetails?.model?.number?.replaceAll(" ", "")}-${
                      MachineDetails.unit_number
                    }`
                  )
                    ?.toLowerCase()
                    .replaceAll(" ", "-");
                  const category = encodeURIComponent(
                    `${MachineDetails?.model?.subcategory?.name
                      ?.toLowerCase()
                      .replaceAll(" ", "-")}`
                  );

                  navigate(
                    `${Path.Inventory}/${category}/${MachineDetails.id}/${encodeURICom}`,
                    {
                      state: MachineDetails,
                    }
                  );
                }
              }}
            >
              {t("Dashboard_Content_Click_here")}
            </Box>

            {/* {`${encodeURIComponent(
              `${MachineDetails?.model?.subcategory?.name?.toLowerCase().replaceAll(" ", "-")}`
            )}/${MachineDetails.id}/${encodeURIComponent(
              `${MachineDetails?.year || ""}-${MachineDetails?.manufacturer?.name}-${MachineDetails?.model?.number}-${
                MachineDetails.unit_number
              }`
            )
              ?.toLowerCase()
              .replaceAll(" ", "-")}`} */}
          </Box>
        </Box>
      </Box>
    </>
  );
};

const MachineListComponent = ({
  copyMachine,
  setCopyMachine,
  selecedEquipment,
  selectCategoryType,
  isMachineData,
  setSelecedEquipment,
  selectedCheckList,
  setSelectedCheckList,
  selectFilter,
  setSelectFilter,
  handelSelectFilter,
  machineRefs,
}) => {
  const [gridView, setGridView] = useState(true);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <Box className="MachineList_Category_box">
        <Box
          display={"flex"}
          alignItems={"center"}
          justifyContent={"space-between"}
          marginBottom={"10px"}
          flexWrap={"wrap"}
        >
          <Box className="MachineList_V2_Category_title">
            {selectCategoryType?.CategoryName}
          </Box>

          <Box display={"flex"} gap={"10px"}>
            <Box
              bgcolor={"#141215"}
              display={"flex"}
              alignItems={"center"}
              sx={{ cursor: "pointer" }}
              width={"40px"}
              height={"40px"}
              justifyContent={"center"}
              onClick={() => setSelectedCheckList(!selectedCheckList)}
            >
              <img src={SelectIcon} alt="" />
            </Box>

            <Box
              bgcolor={"#141215"}
              display={"flex"}
              alignItems={"center"}
              sx={{ cursor: "pointer" }}
              width={"40px"}
              height={"40px"}
              justifyContent={"center"}
              onClick={() => setGridView(!gridView)}
            >
              <img src={GridIcon} alt="" />
            </Box>

            {/* {selectCategoryType?.CategoryId === 38 && (
              <Box
                bgcolor={"#fff"}
                display={"flex"}
                alignItems={"center"}
                sx={{ cursor: "pointer" }}
                width={"40px"}
                height={"40px"}
                justifyContent={"center"}
                onClick={handleClick}
              >
                <img src={FilterIcon} alt="" />
              </Box>
            )} */}
            <Menu
              anchorEl={anchorEl}
              id="account-menu"
              open={open}
              onClose={handleClose}
              slotProps={{
                root: {
                  sx: {
                    ".MuiPaper-elevation": { mt: "10px" },
                    ".MuiList-padding": { py: 0 },
                  },
                },
                paper: {
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                    boxShadow: "0px 10px 50px 0px #00000040",
                    mt: 1.5,
                    "& .MuiAvatar-root": {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    "&::before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      right: 14,
                      width: 10,
                      height: 10,
                      bgcolor: "background.paper",
                      transform: "translateY(-50%) rotate(45deg)",
                      zIndex: 0,
                    },
                  },
                },
              }}
              transformOrigin={{ horizontal: "right", vertical: "top" }}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            >
              <Box padding={"12px 20px"}>
                <Box
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"space-between"}
                >
                  <Box
                    onClick={(e) => {
                      handleClose();
                      setSelectFilter({
                        ...selectFilter,
                        "45,000-80,000lbs": false,
                        "80,001-95,000lbs": false,
                        "95,001-125,000lbs": false,
                      });
                      localStorage.setItem(
                        "selectFilter",
                        JSON.stringify({
                          ...selectFilter,
                          "45,000-80,000lbs": false,
                          "80,001-95,000lbs": false,
                          "95,001-125,000lbs": false,
                        })
                      );
                      handelSelectFilter();
                    }}
                    className="reset_btn"
                    style={{ cursor: "pointer" }}
                  >
                    Reset
                  </Box>
                </Box>

                <Box
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"space-between"}
                >
                  <Box className="drop_down_label">45,000-80,000lbs</Box>
                  <Box>
                    <input
                      type="checkbox"
                      className="drop_down_checkbox"
                      checked={selectFilter?.["45,000-80,000lbs"]}
                      onClick={(e) => {
                        handleClose();
                        setSelectFilter({
                          ...selectFilter,
                          "45,000-80,000lbs": e.target.checked,
                        });
                        localStorage.setItem(
                          "selectFilter",
                          JSON.stringify({
                            ...selectFilter,
                            "45,000-80,000lbs": e.target.checked,
                          })
                        );
                        handelSelectFilter();
                      }}
                    />
                  </Box>
                </Box>

                <Box
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"space-between"}
                >
                  <Box className="drop_down_label">80,001-95,000lbs</Box>
                  <Box>
                    <input
                      type="checkbox"
                      className="drop_down_checkbox"
                      checked={selectFilter?.["80,001-95,000lbs"]}
                      onClick={(e) => {
                        handleClose();
                        setSelectFilter({
                          ...selectFilter,
                          "80,001-95,000lbs": e.target.checked,
                        });
                        localStorage.setItem(
                          "selectFilter",
                          JSON.stringify({
                            ...selectFilter,
                            "80,001-95,000lbs": e.target.checked,
                          })
                        );
                        handelSelectFilter();
                      }}
                    />
                  </Box>
                </Box>

                <Box
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"space-between"}
                >
                  <Box className="drop_down_label">95,001-125,000lbs</Box>
                  <Box>
                    <input
                      type="checkbox"
                      className="drop_down_checkbox"
                      checked={selectFilter?.["95,001-125,000lbs"]}
                      onClick={(e) => {
                        handleClose();
                        setSelectFilter({
                          ...selectFilter,
                          "95,001-125,000lbs": e.target.checked,
                        });
                        localStorage.setItem(
                          "selectFilter",
                          JSON.stringify({
                            ...selectFilter,
                            "95,001-125,000lbs": e.target.checked,
                          })
                        );
                        handelSelectFilter();
                      }}
                    />
                  </Box>
                </Box>
              </Box>
            </Menu>
          </Box>
        </Box>

        <Box
          display={"flex"}
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          {selectedCheckList && (
            <Box
              display={"flex"}
              fontWeight={"bold"}
              alignItems={"center"}
              marginBottom={"10px"}
            >
              <input
                className="checkbox"
                type="checkbox"
                style={{
                  margin: gridView ? "0px 10px 0px 5px" : "3px 7px 0px 13px",
                }}
                checked={
                  isMachineData.length !== 0 &&
                  selecedEquipment.length === isMachineData.length
                }
                onChange={() => {
                  if (selecedEquipment.length === isMachineData.length) {
                    setSelecedEquipment([]);
                  } else {
                    setSelecedEquipment(isMachineData);
                  }
                }}
              />
              <span className="translate-text">Select All</span>
            </Box>
          )}

          {selecedEquipment.length > 0 && selectedCheckList && (
            <Box
              ml={"10px"}
              mr={"10px"}
              sx={{ cursor: "pointer" }}
              className="d-flex"
              marginBottom={"10px"}
            >
              <img
                src={CopyIcon}
                alt=""
                width={"20px"}
                onClick={() => setCopyMachine(!copyMachine)}
              />
            </Box>
          )}
        </Box>
        {gridView ? (
          <Grid
            container
            item
            spacing={"24px"}
            mt={"0px"}
            sx={{ borderTop: "1px solid #eee" }}
          >
            {isMachineData.map((MachineDetails, index) => {
              return (
                <Grid item xs={12} md={6} lg={4}>
                  <GridMachineBox
                    selecedEquipment={selecedEquipment}
                    MachineDetails={MachineDetails}
                    setSelecedEquipment={setSelecedEquipment}
                    selectedCheckList={selectedCheckList}
                    machineRefs={machineRefs}
                    index={index}
                  />
                </Grid>
              );
            })}
          </Grid>
        ) : (
          <Box className="d-flex flex-col">
            {isMachineData.map((MachineDetails, index) => {
              return (
                <MachineBox
                  selecedEquipment={selecedEquipment}
                  MachineDetails={MachineDetails}
                  setSelecedEquipment={setSelecedEquipment}
                  selectedCheckList={selectedCheckList}
                  machineRefs={machineRefs}
                  index={index}
                />
              );
            })}
          </Box>
        )}
      </Box>
    </>
  );
};
export default MachineListComponent;
